var focusDark = {
  "&:focus": {
    "outline": "dashed 1px #53565a !important",
    "outlineOffset": "3px"
  }
};

export { focusDark };
